import { faCirclePlus } from '@fortawesome/free-solid-svg-icons';

import { Icon } from '../Icon';
import type { CustomIconProps } from './types';

/**
 * Renders a circle with plus icon with an optional badge.
 *
 * @see Docs https://fontawesome.com/icons/circle-plus?f=classic&s=solid
 */
export function CirclePlusIcon(props: CustomIconProps) {
  return <Icon icon={faCirclePlus} {...props} />;
}
